import { planSvgChecked, planSvgUnchecked } from './helperFunctions';
import addressFieldsModel from '../models/addressFieldsModel';
import getAddressServiceQualificationManual from './getAddressServiceQualificationManual';
import AppState from '../AppState';
const toggleVisibility = (el, visible) => {
    el.style.display = visible ? 'block' : 'none';
};
const getMultipleServicesAvailable = (addressData) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const addressCheckProgress = AppState.get('addressCheckProgress');
    toggleVisibility(addressCheckProgress, false);
    const elementSelectors = [
        '#multiple-addresses',
        '#multi-address-next',
        '#multi-address-tile',
        '#button-group-multi-addresses',
    ];
    const [multiAddressContainer, multiAddressNext, multiAddressTile, buttonGroupMultiAddresses,] = elementSelectors.map((selector) => context.querySelector(selector));
    toggleVisibility(multiAddressTile, true);
    toggleVisibility(buttonGroupMultiAddresses, true);
    if (addressData.length > 4) {
        multiAddressContainer.classList.add('multiple-addresses-scroll');
    }
    addressData.forEach((data, i) => {
        const addressElement = document.createElement('div');
        addressElement.classList.add('multi-address-tile--confirmation');
        addressElement.innerHTML = `
      <p data-address-id="${i}">${data.Composite}</p>
      <div class="plan-radio">${i === 0 ? planSvgChecked : planSvgUnchecked}</div>
    `;
        multiAddressContainer.appendChild(addressElement);
    });
    // Event delegation from parent to address tiles
    multiAddressContainer.addEventListener('click', (event) => {
        const addressElement = event.target.closest('.multi-address-tile--confirmation');
        if (!addressElement)
            return;
        const selectedRadioElement = addressElement.querySelector('.plan-radio');
        selectedRadioElement.innerHTML = planSvgChecked;
        addressElement.classList.add('selected');
        if (multiAddressContainer instanceof HTMLElement) {
            const otherAddresses = Array.from(multiAddressContainer.children).filter((other) => other !== addressElement);
            otherAddresses.forEach((otherAddress) => {
                otherAddress.classList.remove('selected');
                const radioElement = otherAddress.querySelector('.plan-radio');
                if (radioElement instanceof HTMLElement) {
                    radioElement.innerHTML = planSvgUnchecked;
                }
            });
        }
    });
    multiAddressNext.addEventListener('click', () => {
        const selectedAddress = multiAddressContainer.querySelector('.selected p');
        const addressId = selectedAddress.getAttribute('data-address-id');
        const addressObject = addressData[addressId];
        const requiredAddressFields = addressFieldsModel;
        const addressValues = requiredAddressFields.reduce((acc, field) => { var _a; return (Object.assign(Object.assign({}, acc), { [field]: (_a = addressObject[field]) !== null && _a !== void 0 ? _a : '' })); }, {});
        toggleVisibility(multiAddressTile, false);
        getAddressServiceQualificationManual(addressValues)
            .catch(error => console.log(error));
    });
};
export default getMultipleServicesAvailable;
